// extracted by mini-css-extract-plugin
export default {"brand":"HomePage_brand__Uaia1"};